<template>
	<v-dialog
			content-class="sendDriverStatementsWrapper"
			width="1200"
			:value="true"
			persistent
			transition="dialog-bottom-transition"
	>
		<div class="sendDriverStatements">
			<div class="sendDriverStatements_header">
				<span>Send selected invoices</span>
				<button type="button" @click="onCloseDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="sendDriverStatements_body">
					<table>
						<thead>
							<tr>
								<th width="120">statements ID</th>
								<th>Customer</th>
								<th>Driver</th>
								<th>Amount</th>
								<th>Email</th>
								<th width="125" class="center">Statements</th>
							</tr>
						</thead>
						<tbody>
							<tr :key="id" v-for="({ id, customer, driver, email, statements_amount, pdf }, idx) in sendDriverList">
								<td width="120">{{ id }}</td>
								<td>{{ customer }}</td>
								<td>{{ driver }}</td>
								<td>{{ statements_amount }}</td>
								<td style="padding: 0 10px">
									<div class="textInput">
										<field
												:class-error="$v.sendDriverList && $v.sendDriverList.$each.$iter[idx].$error"
												margin="0"
												width="100%"
												placeholder="Enter email"
												:setInputValue="email"
												@updateInput="onInput"
												:idx="idx"
												is-off-style
										></field>
									</div>
								</td>
								<td width="125" class="center">
									<button @click="onLink(pdf)" :disabled="!pdf" class="view">
										<svg-sprite icon-id="eye" width="20" height="20"></svg-sprite>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
			</div>
			<button-groups
					apply-text="SEND"
					@updateBtnClose="onCloseDialog"
					@updateSave="onSave"
			></button-groups>
		</div>
		<preload v-if="sendDriverStatementsPreloader"></preload>
	</v-dialog>
</template>

<script>
import { mapActions } from "vuex";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
// validate
import { email, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
	name: "SendStatements",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups,
		Preload
	},
	props: {
		selected: Array
	},
	data: () => ({
		//dialog: true,
		sendDriverList: [],
		sendDriverStatementsPreloader: false,
		isEdit: false
	}),
	validations: {
		sendDriverList: {
			$each: {
				email: { required, email },
			}
		}
	},
	methods: {
		...mapActions([ 'getDriverStatementsMails', 'onDriverStatementsSend', 'setAlert' ]),
		onInput({ value, idx }) {
			this.sendDriverList[idx].email = value;
		},
		onLink(value) {
			this.$emit('updateLink', value);
		},
		onCloseDialog() {
			this.$emit('updateClose');
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const values = this.sendDriverList.map(item => ({ id: item.id, email: item.email }));
				const { status } = await this.onDriverStatementsSend(values);
				if (status) {
					this.setAlert({ type: "success", message: "Successfully sent" });
					this.onCloseDialog();
				} else {
					this.setAlert({ type: "error", message: "Send error" });
				}
			} else {
				this.setAlert({ type: "error", message: "Email field is required" });
			}
		}
	},
	async mounted() {
		this.sendDriverStatementsPreloader = true;
		const { rows } = await this.getDriverStatementsMails(this.selected);
		this.sendDriverList = rows;
		this.sendDriverStatementsPreloader = false;
	}
};
</script>

<style scoped lang="scss">
.sendDriverStatements {
	padding: 20px;
	background: #22222D;
	box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);

	.readonly {
		pointer-events: none;
	}

	.textInput {
		display: flex;
		align-items: center;
	}

	.view {
		color: #19BC38;

		&[disabled] {
			color: #8F90A6;
		}
	}

	&_body {
		margin-bottom: 20px;
		background: #2B2B37;

		table {
			width: 100%;
			border-collapse: collapse;

			th:not(:last-child, :first-child) {
				border-left: 1px solid rgba(25, 188, 56, 0.5);
				border-right: 1px solid rgba(25, 188, 56, 0.5);
			}

			th {
				border-bottom: 1px solid rgba(25, 188, 56, 0.5);
				font-weight: 400;
			}

			td:not(:last-child, :first-child) {
				border-left: 1px solid #40404B;
				border-right: 1px solid #40404B;
			}

			td {
				border-bottom: 1px solid #40404B;
			}

			th, td {
				text-align: left;
				font-size: 14px;
				line-height: 20px;
				padding: 10px;
				color: #ffffff;

				&.center {
					text-align: center;
				}
			}

			th {
				color: #71CC82;
			}
		}
	}

	.groupField_wrap {
		position: relative;
		display: flex;
		align-items: flex-start;
		padding: 20px;
		background: #1C1C28;
		z-index: 1;

		&.notPadding {
			padding: 0;
		}
	}

	.boxBtn {
		transition: all .3s ease;
		color: #19BC38;
		&.opened {
			transform: rotate(180deg);
		}

		&:disabled {
			color: var(--card-color);
		}
	}

	.boxDropDown {
		background: #1C1C28;
		position: absolute;
		left: -10px;
		right: 20px;
		bottom: -10px;
		transform: translateY(100%);
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;

		&_item {
			display: flex;
			align-items: center;
			margin: 10px;
		}

		&:after {
			content: '';
			left: 10px;
			right: 10px;
			position: absolute;
			top: 0;
			border-top: 1px solid #19BC38;
		}
	}

	[type="button"] {
		line-height: 1;
	}

	.flexBlock {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&_header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		font-weight: 500;
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.25px;
		color: #FFFFFF;
	}

	.fieldBlock {
		background: #1C1C28;
		border-radius: 4px;
		margin-bottom: 20px;
	}
}
</style>
